import { Input } from "shared/ui/Input";
import { PasswordInput } from "shared/ui/Input";
import { Button } from "shared/ui/button";
import { useLogin } from "../../model/useLogin";
import { useLoginFormValidation } from "../../lib/signInValidation";
import styles from "../FormStyles.module.scss";

export const SignInForm = ({ onForgotPassword, onSuccess }) => {
  const { login, loading, error, clearError } = useLogin();

  const {
    formData,
    fieldErrors,
    handleInputChange,
    handleBlur,
    validateForm,
    resetForm,
  } = useLoginFormValidation({ login: "", password: "" }, clearError);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { isValid } = validateForm();
    if (!isValid || loading) return;

    try {
      await login(formData);
      resetForm();
      onSuccess?.();
    } catch (error) {
      const status = error?.status;

      if (status === 401) {
        return;
      }

      if (status >= 500) {
        return;
      }
    }
  };

  const handleForgotPasswordClick = () => {
    if (onForgotPassword) {
      onForgotPassword();
    }
  };

  return (
    <form className={styles.formWrapper}>
      <div className={styles.formWrapper__form}>
        <div className={styles.formWrapper__formItem}>
          <p className={styles.formWrapper__label}>Логин</p>
          <Input
            type="text"
            value={formData.login}
            onChange={(e) => handleInputChange("login", e.target.value)}
            onBlur={(e) => handleBlur("login", e.target.value)}
            placeholder="Введите логин"
            autoComplete="username"
            className={`${fieldErrors.login ? styles.formWrapper__inputError : styles.formWrapper__input}`}
          />
          {fieldErrors.login && (
            <span className={styles.formWrapper__errorText}>
              {fieldErrors.login}
            </span>
          )}
        </div>
        <div className={styles.formWrapper__formItem}>
          <p className={styles.formWrapper__label}>Пароль</p>
          <PasswordInput
            value={formData.password}
            onChange={(e) => handleInputChange("password", e.target.value)}
            onBlur={(e) => handleBlur("password", e.target.value)}
            placeholder="Введите пароль"
            autoComplete="current-password"
            className={`${fieldErrors.password ? styles.formWrapper__inputError : styles.formWrapper__input} ${styles.formWrapper__passwordBtn}`}
          />
          {fieldErrors.password && (
            <span className={styles.formWrapper__errorText}>
              {fieldErrors.password}
            </span>
          )}
        </div>
        {error && (
          <span className={styles.formWrapper__errorText}>
            {error.status === 401
              ? error.message
              : "Произошла ошибка, попробуйте позже"}
          </span>
        )}
      </div>
      <div className={styles.formWrapper__buttonBlock}>
        <div className={styles.formWrapper__button}>
          <Button
            variant="primary"
            size="large"
            onClick={handleSubmit}
            disabled={loading}
            type="submit"
          >
            {loading ? "Вход..." : "Войти"}
          </Button>
        </div>
        <div
          className={`${styles.formWrapper__greyText} ${styles.formWrapper__cursorPointer}`}
          onClick={handleForgotPasswordClick}
        >
          Забыли пароль?
        </div>
      </div>
    </form>
  );
};
